import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCategories } from "../../api/categoriesApi";
// import { fetchCategories } from "../../api/categories"; // Adjust path as necessary

// Async thunk for fetching categories
export const fetchCategoriesThunk = createAsyncThunk(
  "categories/fetchCategories",
  async ({ has_product_ids }, { rejectWithValue }) => {
    try {
      const response = await fetchCategories(has_product_ids);
      return response.data; // Assuming the response has a `data` property with categories
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Initial state
const initialState = {
  categories: [],
  loading: false,
  error: null,
};

// Slice
const categoriesSlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// Export actions and reducer
export const { clearError } = categoriesSlice.actions;
export default categoriesSlice.reducer;
